import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {quickPurchaseRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {AuctionsList} from './pages/AuctionsList/AuctionsList';

export const QuickPurchaseModule: Module = {
  requiredPermission: permissions.quickPurchaseRead,
  id: moduleKeys.quickPurchase,
  layoutProps: {
    title: 'module.quickPurchase.title',
    icon: 'sidebar/quick_purchase',
  },
  routerProps: {
    path: quickPurchaseRoutes.auctionsList,
    element: <AuctionsList />,
  },
  content: [],
};
